// Clients is one accordion rendered on three dashboards, with Active and
// Historical as a tab inside it. Each dashboard gets its own event because
// each mounts a different component, and only the mounted one can answer.
export const CLIENT_HOME_SECTION_EVENT =
	'canvas-agent:client:home-section';
export const CLIENT_SITE_SECTION_EVENT =
	'canvas-agent:client:site-section';
export const CLIENT_AP_SECTION_EVENT =
	'canvas-agent:client:ap-section';
export const CLIENT_SEARCH_EVENT =
	'canvas-agent:client:search';
export const CLIENT_REFRESH_EVENT =
	'canvas-agent:client:refresh';
export const CLIENT_DISCONNECT_MODAL_EVENT =
	'canvas-agent:client:disconnect-modal';
